<template>
  <BaseModal :modal-id="modalId" :css-classes="['modal-xl']" title="Správa fotografií">
    <div class="mb-3 mt-3 d-flex">
      <div class="input-group mb-3">
        <label class="btn btn-lg btn-gray flex-fill flex-sm-grow-0">
          Nahrát fotografie <input type="file" class="form-control" id="inputGroupFile01" @change="handleFileUploads( $event )" :disabled="this.images.length >= 20" multiple hidden>
        </label>
      </div>
    </div>
    <div class="mb-3 mt-3">
      <div class="alert alert--info alert--lg text-gray-700 position-relative" role="alert">
        <div>
          <a class="alert__toggle text-decoration-none text-gray-1000 fw-normal collapsed" data-bs-toggle="collapse" href="#photosMoreInfo" role="button" aria-expanded="false" aria-controls="photosMoreInfo">
            <span class="alert__toggle-state-active">
              <span class="d-none d-sm-inline-block">méně</span> <i class="icon icon--md icon-caret-up bg-gray-1000 me-0"></i>
            </span>
            <span class="alert__toggle-state">
              <span class="d-none d-sm-inline-block">více</span> <i class="icon icon--md icon-caret-down bg-gray-1000 me-0"></i>
            </span>
          </a>
          <ul class="mb-0">
            <li>Můžete nahrát 1–20 fotografií o velikosti max. 10 MB.</li>
          </ul>
          <ul class="mb-0 collapse" id="photosMoreInfo" style="">
            <li>Ideální poměr stran 4 : 3, ideální rozlišení 1600x1200 pixelů.</li>
            <li>Podporované formáty: JPG, PNG, WebP, TIFF, HEIC</li>
            <li>Větší fotografie budou zmenšeny, menší ponechány v původní velikosti.</li>
            <li>Náhledový obrázek se zobrazí už v seznamu inzerátů. Přesuňte na pozici náhledového obrázku nejvhodnější fotku.</li>
          </ul>
        </div>
      </div>

      <div v-if="error" class="alert alert--error alert--lg my-3" role="alert">
        <i class="icon icon-dismiss-circle"></i>
        {{ error }}
      </div>
    </div>

    <h4 class="mb-3 mt-3">Uspěšně nahrané fotografii</h4>
    <div class="mb-3 mt-3" style="position: relative; min-height: 200px">
      <draggable class="gallery-list" id="gallery-items" :list="images" ghost-class="gallery-list__ghost" handle=".icon-move">
        <transition-group>
        <li v-for="( image, index ) in images" :key="image.uuid" class="gallery-list__item bg-gray-300 rounded-3" style="">
          <div class="gallery-list__image rounded-2" :style="`background-image: url(${image.url})`">

            <!-- Status overlay for uploading/error states -->
            <div v-if="image.status && image.status !== 'done'" class="gallery-list__overlay">

              <!-- Uploading spinner and progress -->
              <div v-if="image.status === 'uploading'" class="gallery-list__status">
                <BaseSpinner/>
                <div class="mt-2 text-white fw-bold">{{ image.progress }}%</div>
              </div>

              <!-- Error icon -->
              <div v-else-if="image.status === 'error'" class="gallery-list__status">
                <i class="icon icon-dismiss-circle" style="font-size: 48px; color: #dc3545;"></i>
                <div class="mt-2 text-white small text-center">{{ image.errorMessage }}</div>
              </div>
            </div>

            <!-- Progress bar at bottom -->
            <div v-if="image.status === 'uploading'" class="gallery-list__progress">
              <div class="progress-bar-upload">
                <div class="progress-bar-upload__line" :style="`width: ${image.progress}%`"></div>
              </div>
            </div>

            <!-- Thumbnail badge -->
            <div v-if="index === 0" class="gallery-list__badges">
              <div class="badge badge-xs-small text-sm-uppercase ls-1">Náhledové foto</div>
<!--                <div class="badge badge-xs-small bg-primary text-sm-uppercase ls-1">Nutno oříznout</div>-->
            </div>
          </div>
          <div class="d-flex justify-content-between p-2 pt-1 gallery-list__action">
            <div class="d-flex">
              <span class="d-flex gallery-list__handle">
                <i class="icon icon--lg icon-move d-none d-md-block"></i>
                <i class="icon icon-move d-block d-md-none"></i>
              </span>
            </div>
            <div class="d-flex">
              <button v-if="false" type="button" class="me-2 me-ms-3 btn-clear d-flex">
                <i class="icon icon--lg icon-edit d-none d-md-block"></i>
                <i class="icon icon-edit d-block d-md-none"></i>
              </button>
              <button
                @click.prevent="removeImage(index)"
                type="button"
                class="btn-clear d-flex"
                :disabled="image.status === 'uploading'"
              >
                <i class="icon icon--lg icon-delete d-none d-md-block"></i>
                <i class="icon icon-delete d-block d-md-none"></i>
              </button>
            </div>
          </div>
        </li>
        </transition-group>
      </draggable>

      <div v-if="isLoading" style="display: flex; justify-content: center; align-items: center; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.1)">
        <BaseSpinner/>
      </div>
    </div>
    <div class="w-100 mb-1 mt-1">
      <div class="progress-bar">
        <div class="progress-bar__line" :style="`width: ${uploadProgress}%`"></div>
      </div>
      <div class="text-gray-1000">
        Nahráno {{ this.images.length }} souborů z 20
      </div>
    </div>

    <template v-slot:ok-button>
      <button @click="save" type="button" class="btn btn-lg btn-gray flex-fill flex-sm-grow-0">Uložit</button>
    </template>
  </BaseModal>
</template>

<script>
import ApiService from "../../services/apiService.js";
import BaseModal from "../modals/BaseModal.vue";
import axios from "axios";
import BaseSpinner from "../general/BaseSpinner.vue";
import { VueDraggableNext } from 'vue-draggable-next'

export default {
  name: 'UploadImagesModal',
  components: {
    BaseSpinner,
    BaseModal,
    draggable: VueDraggableNext,
  },
  data() {
    return {
      isLoading: false,
      error: undefined,
      files: [],
      modalId: 'gearboxes-modal',
    }
  },

  watch: {
    async isOpened(value) {
      if(value) {
        const { data } = await ApiService.get('gearboxes')
        this.$store.dispatch('FilterStore/syncGearboxes', data.gearboxes)
      }
    }
  },

  computed: {
    isOpened() {
      return this.$store.state.ModalStore.openedModalId === this.modalId
    },
    images: {
      get() {
        return this.$store.state.AdvertisementStore.advertisement.images
      },
      set(value) {
        this.$store.commit('AdvertisementStore/images', value)
      }
    },
    uploadProgress() {
      return (this.images.length / 20) * 100
    }
  },

  methods: {
    async handleFileUploads(event) {
      const files = Array.from(event.target.files);
      this.error = undefined;

      // Check maximum photos limit (20)
      const MAXIMUM_PHOTOS = 20;
      const MAXIMUM_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
      const currentCount = this.images.length;
      const newCount = files.length;
      const totalCount = currentCount + newCount;

      if (totalCount > MAXIMUM_PHOTOS) {
        const allowedCount = MAXIMUM_PHOTOS - currentCount;

        // Only upload the allowed number of photos
        if (allowedCount <= 0) {
          this.error = `Můžete nahrát maximálně ${MAXIMUM_PHOTOS} fotografií. Již máte ${currentCount} nahraných.`;
          event.target.value = ''; // Clear input
          return;
        }

        // Show warning and trim files array to allowed count
        this.error = `Můžete nahrát maximálně ${MAXIMUM_PHOTOS} fotografií. Vybráno: ${newCount}, již nahráno: ${currentCount}. Nahraje se pouze prvních ${allowedCount} fotografií.`;
        files.splice(allowedCount);
      }

      // Validate file sizes BEFORE processing to prevent crashes and unnecessary uploads
      const validFiles = [];
      const invalidFiles = [];

      files.forEach(file => {
        if (file.size > MAXIMUM_FILE_SIZE) {
          invalidFiles.push({ name: file.name, size: (file.size / 1024 / 1024).toFixed(1) });
        } else {
          validFiles.push(file);
        }
      });

      // Show error for files exceeding size limit
      if (invalidFiles.length > 0) {
        const errorMessages = invalidFiles.map(f => `${f.name} (${f.size} MB)`).join(', ');
        this.error = `Tyto soubory překračují limit 10 MB: ${errorMessages}`;

        // If no valid files, clear input and return
        if (validFiles.length === 0) {
          event.target.value = '';
          return;
        }
      }

      // 1. Create local previews for all VALID files immediately
      const imagePromises = validFiles.map(file => this.createLocalPreview(file));
      const localImages = await Promise.all(imagePromises);

      // 2. Add local previews to store (user sees them immediately)
      localImages.forEach(image => {
        this.$store.commit('AdvertisementStore/addImage', image);
      });

      // 3. Upload images sequentially with progress tracking
      await this.uploadImagesSequentially(localImages);

      // 4. Clear input
      event.target.value = '';
    },

    createLocalPreview(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve({
            uuid: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            name: file.name,
            url: e.target.result, // blob URL for local preview
            status: 'uploading',
            progress: 0,
            serverUuid: null,
            serverUrl: null,
            file: file,
            errorMessage: null
          });
        };
        reader.readAsDataURL(file);
      });
    },

    async uploadImagesSequentially(localImages) {
      for (let i = 0; i < localImages.length; i++) {
        const imageData = localImages[i];
        const uploadStartTime = performance.now();

        try {
          const serverData = await this.uploadSingleImage(imageData);

          // Update store: status = done, add server data
          this.$store.commit('AdvertisementStore/updateImageStatus', {
            uuid: imageData.uuid,
            status: 'done',
            progress: 100,
            serverUuid: serverData.uuid,
            serverUrl: serverData.url
          });

        } catch (error) {
          // Mark as error
          this.$store.commit('AdvertisementStore/updateImageStatus', {
            uuid: imageData.uuid,
            status: 'error',
            errorMessage: 'Fotka není validní.'
          });

          // Show detailed error to user in global alert
          this.error = error.response?.data?.msg || 'Některé fotky se nepodařilo nahrát';
        }
      }
    },

    async uploadSingleImage(imageData) {
      const formData = new FormData();
      formData.append("images[]", imageData.file);

      const url = `${document.body.dataset.apiUrl}/photos`;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          // Update progress in store
          this.$store.commit('AdvertisementStore/updateImageProgress', {
            uuid: imageData.uuid,
            progress: percentCompleted
          });
        }
      });

      // Return first (and only) image from response
      return response.data.images[0];
    },

    removeImage(index) {
      this.$store.commit('AdvertisementStore/removeImage', index)
    },

    save() {
      this.$store.dispatch('ModalStore/closeModal')
    }
  },
}
</script>
